import cx from 'classnames';
import * as React from 'react';

import './OrganizationEngagementViewSection.scss';

type Props = {
  angle?: boolean;
  children: React.ReactNode;
  className?: string;
  theme?: 'light' | 'dark';
};

export default function OrganizationEngagementViewSection({
  angle,
  children,
  className,
  theme,
}: Props) {
  return (
    <section
      className={cx(
        'OrganizationEngagementViewSection',
        angle && 'OrganizationEngagementViewSection--angle',
        theme && `OrganizationEngagementViewSection--${theme}`,
        className
      )}>
      {children}
    </section>
  );
}

OrganizationEngagementViewSection.defaultProps = {
  angle: true,
  theme: 'light',
};
